import React from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { Home, User, Sparkles, GitBranch, Compass, BookOpen, Shield } from "lucide-react";
import { useAuth, isOwner } from "@/lib/AuthContext";
import { IDS } from "@/constants/testIds";

const NAV = [
  { id: "home", to: "/dashboard", label: "Home", icon: Home },
  { id: "profile", to: "/profile", label: "Profile", icon: User },
  { id: "insights", to: "/insights", label: "Insights", icon: Sparkles },
  { id: "dynamics", to: "/dynamics", label: "Dynamics", icon: GitBranch },
  { id: "field", to: "/field", label: "Field", icon: Compass },
  { id: "library", to: "/library", label: "Library", icon: BookOpen },
];

export default function Layout() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const nav = [...NAV];
  if (isOwner(user)) nav.push({ id: "admin", to: "/admin", label: "Admin", icon: Shield });

  return (
    <div className="min-h-screen w-full flex flex-col" style={{ background: "var(--pa-background)" }}>
      {/* Top nav (desktop) */}
      <header
        className="hidden md:flex items-center justify-between px-8 py-4 border-b"
        style={{ borderColor: "var(--pa-card-border)", background: "rgba(10,10,10,0.9)", backdropFilter: "blur(8px)" }}
      >
        <button
          className="text-xl pa-serif"
          style={{ color: "var(--pa-gold)", letterSpacing: "0.02em" }}
          onClick={() => navigate("/dashboard")}
          data-testid="brand-link"
        >
          Paranormal Archetypes
        </button>
        <nav className="flex items-center gap-1">
          {nav.map((item) => (
            <NavLink
              key={item.id}
              to={item.to}
              data-testid={IDS.navLink(item.id)}
              className={({ isActive }) =>
                `px-3 py-2 rounded-md text-sm transition-colors ${
                  isActive ? "pa-tab-active" : "pa-tab-inactive"
                }`
              }
              style={({ isActive }) =>
                isActive
                  ? { color: "var(--pa-gold)", background: "rgba(201,162,39,0.08)" }
                  : {}
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
      </header>

      {/* Content */}
      <main className="flex-1 pb-24 md:pb-8">
        <div className="mx-auto max-w-4xl w-full px-4 py-6 md:py-10">
          <Outlet />
        </div>
      </main>

      {/* Bottom tab bar (mobile) */}
      <nav
        className="md:hidden fixed bottom-0 left-0 right-0 z-40 flex items-center justify-around border-t px-1 py-1"
        style={{
          background: "rgba(10,10,10,0.96)",
          borderColor: "var(--pa-card-border)",
          backdropFilter: "blur(10px)",
        }}
      >
        {nav.map((item) => {
          const Icon = item.icon;
          return (
            <NavLink
              key={item.id}
              to={item.to}
              data-testid={IDS.navLink(item.id)}
              className="flex flex-col items-center justify-center flex-1 py-2 min-h-[52px]"
            >
              {({ isActive }) => (
                <>
                  <Icon size={20} color={isActive ? "var(--pa-gold)" : "var(--pa-text-muted)"} />
                  <span
                    className="text-[10px] mt-1"
                    style={{ color: isActive ? "var(--pa-gold)" : "var(--pa-text-muted)" }}
                  >
                    {item.label}
                  </span>
                </>
              )}
            </NavLink>
          );
        })}
      </nav>
    </div>
  );
}
